import DeliveryLine from "../shop/DeliveryLine";
import SizeSelector from "../shop/SizeSelector";
import BasketButton from "../shop/BasketButton";
import ProductReview from "../productReview/productReview";
import { ColourSelector } from "../shop/ColourSelector";
import ProductOffer from "../productOffer/ProductOffer";
import { getProductDetailValueLine } from "../../utils/productValueUtils";
import "./ProductDetails.css";

const ProductDetails = ({
  title,
  product,
  displayPrice,
  displaySymbol,
  sizes = [],
  size,
  onSizeChange,
  basketAnim,
  stockStatus,
  onBasketClick,
  selectedColour,
  setSelectedColour,
  deliveryOn,
}) => {
  const inStock =
    !stockStatus || String(stockStatus).toLowerCase().includes("in stock");

  const showColourSelector = product?.colors && product.colors.length > 1;

  return (
    <div className="productDetails-grid_item_content gap-sm">
      <div>
        <h1 className="productDetails-grid-item_content_title">
          {title}
          {displayPrice ? ` — ${displaySymbol || ""}${displayPrice}` : ""}
        </h1>
        {product?.tagline && (
          <p className="productDetails-tagline">{product.tagline}</p>
        )}
      </div>
      <p className="productDetails-value-line">
        {getProductDetailValueLine(product?.category)}
      </p>
      <ProductReview productId={product?.id} />

      {deliveryOn !== false && <DeliveryLine />}

      <div className="sp-divider" />

      {showColourSelector && (
        <ColourSelector
          product={product}
          selectedColour={selectedColour}
          setSelectedColour={setSelectedColour}
        />
      )}

      <SizeSelector sizes={sizes} value={size} onChange={onSizeChange} />

      <ProductOffer selectedProduct={product} />

      <BasketButton
        onClick={onBasketClick}
        disabled={!size || !inStock}
        basketAnim={basketAnim}
        size={size}
        stockStatus={stockStatus}
        product={product}
        displayPrice={displayPrice}
        displaySymbol={displaySymbol}
      />
    </div>
  );
};

export default ProductDetails;
